import { Dialog } from "construct-ui"
import ViewBase from "../view-base.view";


export default function PosmSerialDetailDialog() {
    ViewBase.call(this);
    return {
        view: ({ attrs: { filters, isOpen, onClose, displayItem } }) => {
            return [m(Dialog, {
                isOpen: isOpen,
                onClose: onClose,
                class: 'cui-dialog-l',
                title: this.getText('LT00008066', 'Detail'),
                content: [m("div",
                    m("img.img-fluid",
                        {
                            src: displayItem.photoString
                        }
                    )

                ),
                m(".row.py-4.g-2",
                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001213', 'Asset Serial No')
                        ),
                        m("input.form-control[disabled][value=" + displayItem.serialNo + "]")
                    ),
                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001214', 'Level 1'),
                        ),
                        m("input.form-control[disabled][value=" + displayItem.lvl1 + "]")
                    ),
                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001215', 'Level 2'),
                        ),
                        m("input.form-control[disabled][value=" + displayItem.lvl2 + "]")
                    ),
                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001216', 'Level 3'),
                        ),
                        m("input.form-control[disabled][value=" + displayItem.lvl3 + "]")
                    ),
                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001217', 'Level 4'),
                        ),
                        m("input.form-control[disabled][value=" + displayItem.lvl4 + "]")
                    ),

                    m(".col-md-6",
                        m("label.form-label",
                            this.getText('LT00001268', 'Basic Model')
                        ),
                        m("input.form-control[disabled][value=" + displayItem.lvl5 + "]")
                    ),

                )]
            },

            ), this.getBaseViews()]

        }
    }
}